import React, {useState} from 'react';
import {formatToPhone, toEnglishNumber} from "@helpers/numbers";
import Input from "../../atoms/input";
import Captcha from "../../molecules/auth/captcha";
import ButtonBase from "../../atoms/button.base";
import {handleSubmitTrack} from "../property/crm_requests/crm_requests_track";
import {storePropertyCallRequest} from "../../../models/property";
import {isEmpty, str_replace} from "@helpers/helpers";

const PreContactRequest = ({authName, authMobile, isBadeSaba, property_id, city_id, page, setPreContactRequestShow, handleContactInfo}) => {
    const [submitLoading, setSubmitLoading] = useState(false);
    const [captcha, setCaptcha] = useState({});
    const [fields, setFields] = useState({
        //name: {value: '', error: ''},
        mobile: {value: authMobile, error: ''},
        captcha: {value: '', error: ''},
    });

    const handleChange = (e) => {
        const name = e.target.name;
        let value = e.target.value;

        value = str_replace(' ', '', value);
        value = toEnglishNumber(value);

        setFields(state => ({
            ...state,
            [name]: {value: value, error: ''}
        }))
    };

    const submitRequest = () => {
        setSubmitLoading(true);

        const data = {
            property_id: property_id,
            //name: fields.name.value,
            mobile: fields.mobile.value,
            captcha_code: fields.captcha.value,
            source: (isBadeSaba ? 'badesaba' : '2nabsh'),
            mode: 'contact'
        };

        if (!isEmpty(property_id)) {
            storePropertyCallRequest(data).then(async (result) => {

                localStorage.setItem('pre_contact_request_number', data.mobile);

                handleSubmitTrack(city_id, page, 'contact');

                setPreContactRequestShow(false);

                handleContactInfo();

                setSubmitLoading(false);
            }).catch(err => {
                setSubmitLoading(false);

                if (!isEmpty(err.response) && !isEmpty(err.response.data)) {
                    const response = err.response.data;
                    const items = {...fields};
                    let hasError = false;

                    if (!isEmpty(response) && !isEmpty(response.captcha_token)) {
                        setCaptcha({token: response.captcha_token, error: ''});
                    }

                    if (!isEmpty(response) && !isEmpty(response.errors) && !isEmpty(response.errors.name)) {
                        items['name']['error'] = 'نام و نام خانوادگی‌تون رو وارد کنید.';
                        hasError = true;
                    }

                    if (!isEmpty(response) && !isEmpty(response.errors) && !isEmpty(response.errors.mobile)) {
                        items['mobile']['error'] = 'موبایل‌تون رو اشتباه وارد کردید';
                        hasError = true;
                    }

                    if (!isEmpty(response) && !isEmpty(response.errors) && !isEmpty(response.errors.captcha_token)) {
                        items['captcha']['error'] = 'کد امنیتی رو اشتباه وارد کردید.';
                        hasError = true;
                    }

                    if (hasError) {
                        setFields(items);
                    }
                }
            })
        }
    };

    return (
        <div className="h-100">
            <p className="mt-24">
                برای مشاهده اطلاعات تماس، لطفا موبایل‌تون رو وارد کنید.
            </p>

            <div className="text-right">
                <Input type="tel"
                       name="mobile"
                       onChange={handleChange}
                       value={!isEmpty(fields.mobile.value) ? formatToPhone(fields.mobile.value) : ''}
                       autoCompleteOff={true}
                       className={"mt-16 ltr placeholder-rtl"}
                       isInvalid={(!isEmpty(fields.mobile.error))}
                       invalidFeedback={fields.mobile.error}
                       placeholder="موبایل"/>

                {
                    (!isEmpty(captcha.token)) ?
                        <Captcha
                            handleChange={(e) => handleChange(e)}
                            token={captcha.token}
                            error={captcha.error}
                            captchaValue={fields.captcha.value}
                            className="text-right mt-16"
                        />
                        : ''
                }
            </div>

            <ButtonBase
                onClick={submitRequest}
                color="secondary"
                block
                disabled={submitLoading}
                loadingbar={submitLoading}
                className="mt-24">
                ادامه
            </ButtonBase>
        </div>
    );
};

export default React.memo(PreContactRequest);
